import {Trans} from 'react-i18next';
import React from 'react';

const configs = {
  business: [
    {
      code: 'en',
      i18nKey: 'en',
      text: <Trans i18nKey="business:c.l.h.language.en">English</Trans>,
    },
    {
      code: 'zh_TW',
      i18nKey: 'zh-TW',
      text: <Trans i18nKey="business:c.l.h.language.zh_TW">正體中文</Trans>,
    },
    {
      code: 'zh_CN',
      i18nKey: 'zh-CN',
      text: <Trans i18nKey="business:c.l.h.language.zh_CN">简体中文</Trans>,
    },
    {
      code: 'ja',
      i18nKey: 'ja',
      text: <Trans i18nKey="business:c.l.h.language.ja">日本語</Trans>,
    },
    {
      code: 'fr',
      i18nKey: 'fr',
      text: <Trans i18nKey="business:c.l.h.language.fr">Français</Trans>,
    },
    {
      code: 'ko',
      i18nKey: 'ko',
      text: <Trans i18nKey="business:c.l.h.language.ko">한국어</Trans>,
    },
    {
      code: 'de',
      i18nKey: 'de',
      text: <Trans i18nKey="business:c.l.h.language.de">Deutsch</Trans>,
    },
    {
      code: 'es',
      i18nKey: 'es',
      text: <Trans i18nKey="business:c.l.h.language.es">Español</Trans>,
    },
    {
      code: 'pt',
      i18nKey: 'pt',
      text: <Trans i18nKey="business:c.l.h.language.pt">Português</Trans>,
    },
    {
      code: 'it',
      i18nKey: 'it',
      text: <Trans i18nKey="business:c.l.h.language.it">Italian</Trans>,
    },
    {
      code: 'tr',
      i18nKey: 'tr',
      text: <Trans i18nKey="business:c.l.h.language.tr">Türkçe</Trans>,
    },
    {
      code: 'id',
      i18nKey: 'id',
      text: (
        <Trans i18nKey="business:c.l.h.language.id">Bahasa Indonesian</Trans>
      ),
    },
    {
      code: 'ru',
      i18nKey: 'ru',
      text: <Trans i18nKey="business:c.l.h.language.ru">Русский язык</Trans>,
    },
    {
      code: 'th',
      i18nKey: 'th',
      text: <Trans i18nKey="business:c.l.h.language.th">ภาษาไทย</Trans>,
    },
    {
      code: 'gn',
      i18nKey: 'gn',
      text: <Trans i18nKey="business:c.l.h.language.gn">Avañe'ẽ</Trans>,
      showInMenu: false,
    },
    {
      code: 'he',
      i18nKey: 'he',
      text: <Trans i18nKey="business:c.l.h.language.he">עברית</Trans>,
      showInMenu: false,
    },
    {
      code: 'ar',
      i18nKey: 'ar',
      text: <Trans i18nKey="business:c.l.h.language.ar">العربية</Trans>,
      showInMenu: false,
    },
    {
      code: 'pl',
      i18nKey: 'pl',
      text: <Trans i18nKey="business:c.l.h.language.pl">Polski</Trans>,
    },
    {
      code: 'nl',
      i18nKey: 'nl',
      text: <Trans i18nKey="business:c.l.h.language.nl">Nederlands</Trans>,
    },
    {
      code: 'tl',
      i18nKey: 'tl',
      text: <Trans i18nKey="business:c.l.h.language.tl">Filipino</Trans>,
      showInMenu: false,
    },
    {
      code: 'ro',
      i18nKey: 'ro',
      text: <Trans i18nKey="business:c.l.h.language.ro">Română</Trans>,
      showInMenu: false,
    },
    {
      code: 'af',
      i18nKey: 'af',
      text: <Trans i18nKey="business:c.l.h.language.af">Afrikaans</Trans>,
      showInMenu: false,
    },
    {
      code: 'uk',
      i18nKey: 'uk',
      text: <Trans i18nKey="business:c.l.h.language.uk">Українська</Trans>,
      showInMenu: false,
    },
    {
      code: 'el',
      i18nKey: 'el',
      text: <Trans i18nKey="business:c.l.h.language.el">Ελληνικά</Trans>,
      showInMenu: false,
    },
    {
      code: 'sv',
      i18nKey: 'sv',
      text: <Trans i18nKey="business:c.l.h.language.sv">Svenska</Trans>,
      showInMenu: false,
    },
    {
      code: 'hu',
      i18nKey: 'hu',
      text: <Trans i18nKey="business:c.l.h.language.hu">Magyar</Trans>,
      showInMenu: false,
    },
    {
      code: 'bg',
      i18nKey: 'bg',
      text: <Trans i18nKey="business:c.l.h.language.bg">Български</Trans>,
      showInMenu: false,
    },
    {
      code: 'da',
      i18nKey: 'da',
      text: <Trans i18nKey="business:c.l.h.language.da">Dansk</Trans>,
      showInMenu: false,
    },
    {
      code: 'hr',
      i18nKey: 'hr',
      text: <Trans i18nKey="business:c.l.h.language.hr">Hrvatski</Trans>,
      showInMenu: false,
    },
    {
      code: 'vi',
      i18nKey: 'vi',
      text: <Trans i18nKey="business:c.l.h.language.vi">Tiếng Việt</Trans>,
    },
  ],
  consumer: [
    {
      code: 'en',
      i18nKey: 'en',
      text: <Trans i18nKey="business:c.l.h.language.en">English</Trans>,
    },
    {
      code: 'zh_TW',
      i18nKey: 'zh-TW',
      text: <Trans i18nKey="business:c.l.h.language.zh_TW">正體中文</Trans>,
    },
    // {
    //   code: 'zh_CN',
    //   i18nKey: 'zh-CN',
    //   text: <Trans i18nKey="business:c.l.h.language.zh_CN">简体中文</Trans>,
    // },
    {
      code: 'ja',
      i18nKey: 'ja',
      text: <Trans i18nKey="business:c.l.h.language.ja">日本語</Trans>,
    },
    {
      code: 'ko',
      i18nKey: 'ko',
      text: <Trans i18nKey="business:c.l.h.language.ko">한국어</Trans>,
    },
    {
      code: 'de',
      i18nKey: 'de',
      text: <Trans i18nKey="business:c.l.h.language.de">Deutsch</Trans>,
    },
    {
      code: 'fr',
      i18nKey: 'fr',
      text: <Trans i18nKey="business:c.l.h.language.fr">Français</Trans>,
    },
    {
      code: 'es',
      i18nKey: 'es',
      text: <Trans i18nKey="business:c.l.h.language.es">Español</Trans>,
    },
    {
      code: 'pt',
      i18nKey: 'pt',
      text: <Trans i18nKey="business:c.l.h.language.pt">Português</Trans>,
    },
    {
      code: 'it',
      i18nKey: 'it',
      text: <Trans i18nKey="business:c.l.h.language.it">Italian</Trans>,
    },
    {
      code: 'tr',
      i18nKey: 'tr',
      text: <Trans i18nKey="business:c.l.h.language.tr">Türkçe</Trans>,
    },
    {
      code: 'id',
      i18nKey: 'id',
      text: (
        <Trans i18nKey="business:c.l.h.language.id">Bahasa Indonesian</Trans>
      ),
    },
    {
      code: 'ru',
      i18nKey: 'ru',
      text: <Trans i18nKey="business:c.l.h.language.ru">Русский язык</Trans>,
    },
    {
      code: 'th',
      i18nKey: 'th',
      text: <Trans i18nKey="business:c.l.h.language.th">ภาษาไทย</Trans>,
    },
    {
      code: 'gn',
      i18nKey: 'gn',
      text: <Trans i18nKey="business:c.l.h.language.gn">Avañe'ẽ</Trans>,
      showInMenu: false,
    },
    {
      code: 'he',
      i18nKey: 'he',
      text: <Trans i18nKey="business:c.l.h.language.he">עברית</Trans>,
      showInMenu: false,
    },
    {
      code: 'ar',
      i18nKey: 'ar',
      text: <Trans i18nKey="business:c.l.h.language.ar">العربية</Trans>,
      showInMenu: false,
    },
    {
      code: 'pl',
      i18nKey: 'pl',
      text: <Trans i18nKey="business:c.l.h.language.pl">Polski</Trans>,
    },
    {
      code: 'nl',
      i18nKey: 'nl',
      text: <Trans i18nKey="business:c.l.h.language.nl">Nederlands</Trans>,
    },
    {
      code: 'tl',
      i18nKey: 'tl',
      text: <Trans i18nKey="business:c.l.h.language.tl">Filipino</Trans>,
      showInMenu: false,
    },
    {
      code: 'ro',
      i18nKey: 'ro',
      text: <Trans i18nKey="business:c.l.h.language.ro">Română</Trans>,
      showInMenu: false,
    },
    {
      code: 'af',
      i18nKey: 'af',
      text: <Trans i18nKey="business:c.l.h.language.af">Afrikaans</Trans>,
      showInMenu: false,
    },
    {
      code: 'uk',
      i18nKey: 'uk',
      text: <Trans i18nKey="business:c.l.h.language.uk">Українська</Trans>,
      showInMenu: false,
    },
    {
      code: 'el',
      i18nKey: 'el',
      text: <Trans i18nKey="business:c.l.h.language.el">Ελληνικά</Trans>,
      showInMenu: false,
    },
    {
      code: 'sv',
      i18nKey: 'sv',
      text: <Trans i18nKey="business:c.l.h.language.sv">Svenska</Trans>,
      showInMenu: false,
    },
    {
      code: 'hu',
      i18nKey: 'hu',
      text: <Trans i18nKey="business:c.l.h.language.hu">Magyar</Trans>,
      showInMenu: false,
    },
    {
      code: 'bg',
      i18nKey: 'bg',
      text: <Trans i18nKey="business:c.l.h.language.bg">Български</Trans>,
      showInMenu: false,
    },
    {
      code: 'da',
      i18nKey: 'da',
      text: <Trans i18nKey="business:c.l.h.language.da">Dansk</Trans>,
      showInMenu: false,
    },
    {
      code: 'hr',
      i18nKey: 'hr',
      text: <Trans i18nKey="business:c.l.h.language.hr">Hrvatski</Trans>,
      showInMenu: false,
    },
    {
      code: 'vi',
      i18nKey: 'vi',
      text: <Trans i18nKey="business:c.l.h.language.vi">Tiếng Việt</Trans>,
    },
  ],
};

export default configs;
